@if (params()?.value) {
  <div
    [ngClass]="{
      'last-command-status-cell': true,
      'capitalize-first-letter': true,
      'last-command-status-cell-success': params()?.value === DeviceLastCommandStatus.COMPLETED,
      'last-command-status-cell-failure': params()?.value === DeviceLastCommandStatus.FAILED
    }"
  >
    <span>
      {{ 'DEVICES.COMMANDS_STATUSES.' + $safeNavigationMigration(params()?.value) | translate }}
    </span>
  </div>
} @else {
  <div class="last-command-status-cell">-</div>
}
